import React, { useState, useEffect } from "react";
import axios from "axios";
import { getAssembleLocation } from "../../Utilities/URLCONSTANTS";
import Select from "react-select";

function CorePermitEmergency(props) {
  const [assemblyLocations, setAssemblyLocations] = useState([]);

  const handleGeneralInfo = (selectedOption) => {
    if (selectedOption) {
      const obj = {
        assemblyLocation: selectedOption.name,
        phoneNumber: selectedOption.mobileNumber,
      };
      props.setEmergency(obj);
    }
  };

  const getLocations = async () => {
    const apiUrl = getAssembleLocation;
    try {
      const response = await axios.get(apiUrl);
      console.log("responseLocation", response);
      setAssemblyLocations(response.data.response.assembleLocations);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getLocations();
    console.log(props.data, "Emergency");
  }, []);

  
  // added for select custom styles
  const customSelectStyles = {
    option: (provided, state) => ({
      ...provided,

      // Custom background color based on state
      backgroundColor: state.isSelected
        ? 'var(--theme-bg-primary-color)' // Selected background color
        : state.isFocused
        ? 'var(--theme-input-focus-color)' // Hover/Focus background color
        : '#ffffff', // Default background color

      // Custom text color based on state
      color: state.isSelected
        ? '#ffffff' // Selected text color
        : state.isFocused
        ? '#333333' // Hover/Focus text color
        : '#333333', // Default text color

      // Keeps the click/active state looking clean
      ':active': {
        ...provided[':active'],
        backgroundColor: 'var(--theme-bg-primary-color)',
        color: '#ffffff',
      },
    }),
    // 2. Customize the input border focus color
    control: (provided, state) => ({
      ...provided,
      // Changes the border color when focused vs default state
      borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor, 
      
      // Removes the default blue glow and replaces it (or set to 'none')
      boxShadow: state.isFocused ? '0 0 0 1px var(--theme-input-focus-color)' : provided.boxShadow, 
      
      // Prevents the border from changing back to blue on hover while focused
      '&:hover': {
        borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor,
      }
    }),
  };


  return (
    <div className="m-2">
      <div className="row">
        <div>
          <div className="form-group">
            <label htmlFor="inputAssemblyLocation">
              Assembly Location <span style={{ color: "red" }}> *</span>
            </label>
            <br />
            <Select
              className="basic-single"
              classNamePrefix="select"
              isSearchable={true}
              menuPlacement="auto"
              options={assemblyLocations}
              value={assemblyLocations.find(
                (option) => option.name === props.data.assemblyLocation
              )}
              onChange={handleGeneralInfo}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              placeholder="Select Assembly Location & Search..."
              styles={customSelectStyles}
            />
          </div>

          <div className="form-group">
            <label htmlFor="inputPhoneNumber">
              Phone Number<span style={{ color: "red" }}> *</span>
            </label>
            <div>
              <input
                className="form-control"
                id="ph"
                type="text"
                maxLength={12}
                readOnly={props.approvalStatus}
                value={props.data.phoneNumber}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CorePermitEmergency;
